// eslint-disable-next-line jira/filename-case
import { fg } from '@atlassian/jira-feature-gating';

/**
 * Centralized helpers for feature gates used by Assets Dashboards/Reports.
 *
 * Main rollout gate: controls introduction of Dashboards and legacy treatment for Reports.
 * Permission gate: controls Dashboards visibility for non-admin users when main gate is enabled.
 */
export const FEATURE_GATES = {
	main: 'assets-reports-and-dashboard-navigation',
	eap: 'new_assets_reports_avp_experience',
} as const;

export type FeatureGateKey = (typeof FEATURE_GATES)[keyof typeof FEATURE_GATES] | string;

// eslint-disable-next-line jira/ff/static-feature-flags
export const isFeatureEnabled = (key: FeatureGateKey): boolean => Boolean(fg(key));

export const isMainGateEnabled = (): boolean => isFeatureEnabled(FEATURE_GATES.main);

export const isNewReportsNavExperienceEnabled = (): boolean =>
	isFeatureEnabled(FEATURE_GATES.main) && isFeatureEnabled(FEATURE_GATES.eap);

export const isEAPEnabled = (): boolean => isFeatureEnabled(FEATURE_GATES.eap);
